import React from "react";
import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import HamburgerIcon from "@material-ui/icons/Dehaze";
import PropTypes from "prop-types";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import { REACT_APP_NAME } from "../const/sysytem";
import {
  CUSTOMER_INFO,
  CUSTOMER_DELETE_MEMO,
  PASSWORD_UPDATE,
} from "../const/mount_list";

const styles = (theme) => ({
  appBar: {
    position: "relative",
    backgroundColor: "#3F51C1",
  },
  icon: {
    color: "#FFFFFF",
    marginRight: theme.spacing(2),
    position: "absolute",
    top: "50%",
    left: "0%",
    transform: "translateY(-50%)",
  },
  appName: {
    position: "absolute",
    top: "50%",
    left: "10%",
    transform: "translateY(-50%)",
  },
  screenName: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translateY(-50%) translateX(-50%)",
  },
  accountName: {
    position: "absolute",
    top: "50%",
    left: "80%",
    transform: "translateY(-50%) translateX(-50%)",
  },
  logout: {
    position: "absolute",
    top: "50%",
    right: "5%",
    transform: "translateY(-50%)",
  },
});

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
    };
    this.setAnchorEl = this.setAnchorEl.bind(this);
  }

  setAnchorEl = (element) => {
    this.setState({ anchorEl: element });
  };

  menuClick = (event) => {
    this.setAnchorEl(event.currentTarget);
  };

  menuClose = () => {
    this.setAnchorEl(null);
  };

  customerInfoClick = () => {
    this.props.setMountTarget(CUSTOMER_INFO);
    this.menuClose();
  };

  customerDeleteMemoClick = () => {
    this.props.setMountTarget(CUSTOMER_DELETE_MEMO);
    this.menuClose();
  };

  passwordUpdateClick = () => {
    this.props.setMountTarget(PASSWORD_UPDATE);
    this.menuClose();
  };

  logout() {
    const { updateParent, setAccountName, setAccountId } = this.props;
    setAccountName("");
    setAccountId("");
    updateParent("logout");
  }

  render() {
    const { classes, subtitle } = this.props;
    const { anchorEl } = this.state;
    return (
      <AppBar position="static" className={classes.appBar}>
        <Toolbar>
          <Button
            aria-controls="simple-menu"
            aria-haspopup="true"
            className={classes.icon}
            onClick={this.menuClick}
          >
            <HamburgerIcon />
          </Button>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={this.menuClose}
          >
            <MenuItem
              style={{
                marginRight: "20px",
                marginLeft: "20px",
              }}
              onClick={this.customerInfoClick}
            >
              顧客情報検索
            </MenuItem>
            <MenuItem
              style={{
                marginRight: "20px",
                marginLeft: "20px",
              }}
              onClick={this.passwordUpdateClick}
            >
              パスワード再設定
            </MenuItem>
            <MenuItem
              style={{
                marginRight: "20px",
                marginLeft: "20px",
              }}
              onClick={this.customerDeleteMemoClick}
            >
              顧客明細メモ削除 ~デジタルバンキング部専用~
            </MenuItem>
          </Menu>
          <Typography
            variant="subtitle2"
            color="inherit"
            className={classes.appName}
            noWrap
            style={{ textDecoration: "none" }}
          >
            {REACT_APP_NAME}
          </Typography>
          <Typography
            variant="subtitle2"
            color="inherit"
            className={classes.screenName}
            noWrap
            style={{ textDecoration: "none" }}
          >
            {subtitle}
          </Typography>
          <Typography
            variant="subtitle2"
            color="inherit"
            className={classes.accountName}
            noWrap
            style={{ textDecoration: "none" }}
          >
            社員名：{decodeURIComponent(this.props.accountName)}
          </Typography>
          <Button
            className={classes.logout}
            color="inherit"
            onClick={() => this.logout()}
          >
            ログアウト
          </Button>
        </Toolbar>
      </AppBar>
    );
  }
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
  subtitle: PropTypes.string.isRequired,
  updateParent: PropTypes.func.isRequired,
  setMountTarget: PropTypes.func.isRequired,
  accountName: PropTypes.string.isRequired,
  setAccountName: PropTypes.func.isRequired,
};

export default withStyles(styles)(Header);
